<template>
    <div>
        <b-form :model="loginForm" class="form-style m-auto">
            <b-form-group
                id="username"
                label="用户名"
                class="mt-3"
                label-for="input-1"
            >
                <b-form-input
                    id="input-1"
                    class="mt-1"
                    v-model="loginForm.username"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label="密 码:" label-for="input-2" class="mt-3">
                <b-form-input
                    id="password"
                    class="mt-1"
                    v-model="loginForm.password"
                    type="password"
                    required
                ></b-form-input>
            </b-form-group>
            <span v-if="showPasswordError" class="text-danger">{{ passwordError }}</span>
            <b-button v-if="showSubmitButton" @click="onSubmit" type="submit" size="md" pill block class="mt-3 mb-5"
                      style="font-size: 14px"
                      variant="primary">
                登录
            </b-button>
        </b-form>
        <ReBModal ref="verificationCode" header="安全验证" hide-footer close-on-click-modal no-close-on-backdrop>
            <EmVerificationCode :loginForm="loginForm"></EmVerificationCode>
        </ReBModal>
    </div>
</template>

<script>


import emLoginMixin from "@/mixin/em/common/stuffs/login/emLoginMixin";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import EmVerificationCode from "@/components/em/login/VerificationCode.vue";

export default {
    name: "PasswordLogin",
    components: {ReBModal, EmVerificationCode},
    mixins: [emLoginMixin],
    props: {
        showSubmitButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loginForm: {
                username: '',
                password: '',
                mobilePhone: '',
                userRealName: '',

            },
            smsRequestForm: {
                mobilePhone: '',
                businessType: '',
            },
            passwordError: '密码错误，请输入正确的密码',
            showPasswordError: false,
            phone: '',
        }
    },
    computed: {},
    methods: {
        async getUserByPassword() {
            try {
                const response = await this.$store.dispatch("api/post", {
                    url: this.$store.state.emAclUser.baseModuleUrl + "/emAclUser/getUserByPassword",
                    data: this.loginForm,
                });
                const userId = response.data.id;
                if (userId) {
                    this.showPasswordError = false;
                    return userId;
                } else {
                    this.showPasswordError = true;
                    return null;
                }
            } catch (error) {
                console.error(error);
                return null;
            }
        },
        reset() {
            this.showPasswordError = false
            this.username = ''
            this.password = ''
        },
        onSubmit(event) {
            event.preventDefault();
            if (this.loginForm.username === '' || this.loginForm.password === '') {
                this.passwordError = '用户名或密码不能为空';
                this.showPasswordError = true;
                return;
            }

            function commonLogin() {
                this.$store.dispatch("api/post", {
                    url: this.$store.state.emAclUser.baseModuleUrl + "/sso/login",
                    data: this.loginForm,
                }).then((response) => {
                    const data = response.data
                    if (data) {
                        if (data.code !== 200) {
                            this.passwordError = '密码错误，请输入正确的密码';
                            this.showPasswordError = true;
                        } else {
                            this.redirectFromLogin(data)
                        }
                    }
                })
            }

            // 校验是否开启手机号校验,未开启普通登录
            this.$store.dispatch("api/post", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/emAdmSysParam/findValueByKey" + `?key=${this.checkPhoneKey}`,
            }).then((result) => {
                const valueData = result;
                if (valueData === undefined || valueData.data === null || valueData.data === false || valueData.status !== 200) {
                    commonLogin.call(this);
                } else {
                    this.$store.dispatch("api/post", {
                        url: this.$store.state.emAclUser.baseModuleUrl + "/sso/checkPasswordAndPhone",
                        data: this.loginForm,
                    }).then((response) => {
                        const data = response.data
                        if (data) {
                            if (data.code !== 200) {
                                this.$store.dispatch("api/post", {
                                    url: this.$store.state.emAclUser.baseModuleUrl + "/emAdmSysParam/findValueByKey" + `?key=${this.forceCheckPhoneKey}`,
                                }).then((result) => {
                                    const valueData = result;
                                    // 校验是否强制手机号校验,查到配置并且为true才会抛错，否则走通常登录方法
                                    if (valueData && valueData.status === 200 && valueData.data === true) {
                                        this.showPasswordError = true;
                                        this.passwordError = data.message;
                                    } else {
                                        commonLogin.call(this);
                                    }
                                })
                            } else {
                                this.smsRequestForm.mobilePhone = data.data.emAclUser.telephone;
                                this.loginForm.mobilePhone = data.data.emAclUser.telephone;
                                this.loginForm.userRealName = data.data.emAclUser.name;
                                this.smsRequestForm.businessType = 'USER_LOGIN';
                                this.loginForm.businessType = 'USER_LOGIN';
                                this.$store.dispatch("api/post", {
                                    url: this.$store.state.emAclUser.baseModuleUrl + "/sso/sendVerifyCode",
                                    data: this.smsRequestForm,
                                }).then((response) => {
                                    const data = response.data
                                    if (data) {
                                        if (data.code !== 200) {
                                            this.passwordError = data.message;
                                            this.showPasswordError = true;
                                        } else {
                                            this.$refs.verificationCode.showModal()
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            })
        },

    }
}
</script>

<style scoped>

.login-head {
    text-align: center;
}

.form-style {
    //width: 350px;
    width: 100%;
}
</style>
